import React, { useContext, useState, useEffect } from "react";
import { auth, db } from "../firebase";
import { collection, setDoc, addDoc, doc, Timestamp, onSnapshot } from "firebase/firestore";
import {
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  sendEmailVerification,
  getIdTokenResult,
  GoogleAuthProvider,
  signInWithPopup,
  signInWithCustomToken as signInWithCustomTokenFirebase,
  getIdToken
} from "firebase/auth";
import axios from "axios";
import constraints from "../constraints";

const AuthContext = React.createContext()

export function useAuth() {
  return useContext(AuthContext)
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState();
  const [loading, setLoading] = useState(true);

  async function signup(email, password) {
    try {
      const cred = await createUserWithEmailAndPassword(auth, email, password)
      return cred.user
    } catch (error) {
      if (error.code === "auth/email-already-in-use") {
        alert("이미 사용중인 이메일입니다.")
      }

      // console.log(error.code)

      return null
    }
  }

  async function getToken () {
    return await getIdToken(currentUser)
  }

  async function getSubscriptionStatus() {
    const token = await getToken();
    const { data } = await axios.get("https://us-central1-art-generator-5a6dd.cloudfunctions.net/api/purchase/subscriptionStatus", {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    return {
      isRegisteredCard: data.isRegisteredCard,
      isSubscriptionActivated: data.isSubscriptionActivated
    }
  }

  function login(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }

  function logout() {
    return auth.signOut()
  }

  function resetPassword(email) {
    return sendPasswordResetEmail(auth, email);
  }

  function updateEmail(email) {
    return currentUser.updateEmail(email)
  }

  function updatePassword(password) {
    return currentUser.updatePassword(password)
  }

  async function googleLogin() {
    let provider = new GoogleAuthProvider()

    try {
      const results = await signInWithPopup(auth, provider)
      const credential = GoogleAuthProvider.credentialFromResult(results);
      const token = credential.accessToken;
      // The signed-in user info.
      return results.user;
    } catch (error) {
      const errorCode = error.code;
      const errorMessage = error.message;
      // The email of the user's account used.
      const email = error.email;
      // The AuthCredential type that was used.
      const credential = GoogleAuthProvider.credentialFromError(error);
    }

  }

  // 카카오톡 로그인
  // 봇 아이디가 존재하면 봇 아이디 정보를 카카오 인증 데이터에 저장한다.
  async function signInWithKakao(code, botId, redirectPath) {
    const { data } = await axios.post(
      "https://kauth.kakao.com/oauth/token", {
        code,
        redirect_uri: `${constraints.config.HOST_URL}${redirectPath}`,
        grant_type: "authorization_code",
        client_id: "506156205343417c8a22984b62147e4e"
      },
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }
    );

    const response = await axios.post("https://us-central1-art-generator-5a6dd.cloudfunctions.net/api/user/signin/kakao", {
      accessToken: data.access_token,
      botId
    });

    try {
      await signInWithCustomTokenFirebase(auth, response.data.token);
    } catch (error) {
      throw error;
    }
  }

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      setCurrentUser(user)
      setLoading(false)
    })

    return unsubscribe
  }, [])

  const value = {
    currentUser,
    login,
    signup,
    logout,
    resetPassword,
    updateEmail,
    updatePassword,
    googleLogin,
    signInWithKakao,
    getToken,
    getSubscriptionStatus
  }

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  )
}